<app-connector-requests></app-connector-requests>
<app-con-x-table-page eyebrow="Construct-X" eyebrowIcon="admin_panel_settings" title="SaaS-Serviceverwaltung"
  [description]="description" ariaLabel="Entdeckte Docker-Stacks" locale="de-DE" searchPlaceholder="Docker-Stack suchen"
  countLabel="Docker-Stacks" refreshTooltip="Discovery aktualisieren" loadingMessage="Docker-Stacks werden ermittelt …"
  errorTitle="n8n-Discovery nicht erreichbar" retryLabel="Erneut laden" noResultsTitle="Keine passenden Docker-Stacks"
  noResultsDescription="Ändern Sie den Suchbegriff." [data]="stacks" [columns]="columns" [summaryItems]="summaryItems"
  [actions]="actions" [rowActions]="rowActions"
  [selectedRow]="selectedStack" [emptyState]="emptyState" [loading]="loading" [refreshing]="refreshing"
  [errorMessage]="errorMessage" [refreshable]="true" [selectableRows]="true" [pageSize]="25"
  (pageAction)="handlePageAction($event)" (selectedRowChange)="openStack($event)"
  (rowAction)="handleRowAction($event)"
  (refreshRequested)="refresh()" (retryRequested)="retry()">
</app-con-x-table-page>
